// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// DRAG/WHEEL SCROLL-X + MOMENTUM
// PAUSE OUT-OF-VIEW VIDEO
// YT VIDEO MODAL


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});

//
// =REMOVE GRID CELLS / EMPTY PRODUCT CARDS
// --------------------------------------------------

const prodCards = document.querySelectorAll('.msdw-filter-content');

window.addEventListener("load", (e) => {
  prodCards.forEach(prodCard => {
    if (prodCard.children[0].tagName === 'WAINCLUDE') {
      prodCard.style.display = 'none';
    };
  });
});

//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

Splitting();

const scroll = window.requestAnimationFrame;

function showOnScroll() {
  const elems = document.querySelectorAll(
    ".msdw-animate, .msdw-anim-skew, .msdw-anim-zoom"
  );

  elems.forEach((el) => {
    const elPosition = el.getBoundingClientRect().top;
    const elScreen = window.innerHeight / 0.9;

    if (elPosition < elScreen) {
      el.classList.add("msdw-animated");
    }
  });

  scroll(showOnScroll);
}

showOnScroll();


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const sliderNav = new Swiper("#sliderNav", {
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 10,
  freeMode: true,
  breakpoints: {
    900: {
      spaceBetween: 15,
    },
  },
});


function resetsliderNav() {
  if (!sliderNav.isIntersecting) {
    resetSliderNav(sliderNav);
  }
}

const observer3 = new IntersectionObserver(resetsliderNav);

observer3.observe(document.getElementById('sliderNav'));


//
// =DRAG/WHEEL SCROLL-X + MOMENTUM
// --------------------------------------------------

const scrollers = document.querySelectorAll('.msdw-section-profile');

let isDown = false;
let startX;
let scrollLeft;

scrollers.forEach(scroller => {
  scroller.addEventListener('mousedown', (e) => {
    isDown = true;
    scroller.classList.add('active');
    startX = e.pageX - scroller.offsetLeft;
    scrollLeft = scroller.scrollLeft;
    cancelMomentumTracking();
  });

  scroller.addEventListener('mouseleave', () => {
    isDown = false;
    scroller.classList.remove('active');
  });

  scroller.addEventListener('mouseup', () => {
    isDown = false;
    scroller.classList.remove('active');
    beginMomentumTracking();
  });

  scroller.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - scroller.offsetLeft;
    // scroll-fast
    // const walk = (x - startX) * 3;
    const walk = (x - startX) * 1;
    var prevScrollLeft = scroller.scrollLeft;
    scroller.scrollLeft = scrollLeft - walk;
    velX = scroller.scrollLeft - prevScrollLeft;
  });

  // Reset scroller position when not in-view

  function resetScroller() {
    if (!scroller.isIntersecting) {
      scroller.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  const observer2 = new IntersectionObserver(resetScroller);

  observer2.observe(scroller);

  // Momentum

  var velX = 0;
  var momentumID;

  scroller.addEventListener('wheel', (e) => {
    cancelMomentumTracking();
  });

  function beginMomentumTracking(){
    cancelMomentumTracking();
    momentumID = requestAnimationFrame(momentumLoop);
  }
  function cancelMomentumTracking(){
    cancelAnimationFrame(momentumID);
  }
  function momentumLoop(){
    scroller.scrollLeft += velX;
    velX *= 0.95;
    if (Math.abs(velX) > 0.5){
      momentumID = requestAnimationFrame(momentumLoop);
    }
  }
});


//
// =PAUSE OUT-OF-VIEW VIDEO
// --------------------------------------------------

const videos = document.querySelectorAll("video");

const config = {
  rootMargin: '0px -100px',
  threshold: 0
}

const callback = (entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      entry.target.pause();
      // alert('Exit video');
    } else {
      entry.target.play();
      // alert('Enter video');
    }
  });
}

const observer = new IntersectionObserver(callback, config);

videos.forEach(element => {
  observer.observe(element);
});


//
// =YT VIDEO MODAL
// --------------------------------------------------

$(".js-trigger-video-modal")
  .on("click", function(e){
    e.preventDefault();
    var id = $(this).attr('data-youtube-id');
    // var enablejsapi = '?enablejsapi=1';
    var autoplay = '?autoplay=1';
    var related_no = '&rel=0';
    var captions = '&cc_load_policy=1';
    // var src = '//www.youtube.com/embed/'+id+enablejsapi+autoplay+related_no;
    var src = '//www.youtube.com/embed/'+id+autoplay+related_no+captions;
    console.log(src);

    $("#youtube").attr('src', src);
    $("body").addClass("show-video-modal noscroll");
  });

function close_video_modal() {
  $("body").removeClass("show-video-modal noscroll");
  $("#youtube").attr('src', '');
}

$('body').on('click', '.close-video-modal, .video-modal .overlay', function(event) {
  close_video_modal();
});

$('body').keyup(function(e) {
  if (e.keyCode == 27) {
    close_video_modal();
  }
});
